import { NumberField, SelectField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const selectCss = "s19xoblp";
const Select = forwardRef((props, ref) => <SelectField ref={ref} {...props} className={classNames(selectCss, props.className)} />);
export const NoticePeriodForm = () => {
  const selectOptions = [{
    id: 'mins',
    name: I18n.t('publisher.event_types.one_off.units.minutes')
  }, {
    id: 'hours',
    name: I18n.t('publisher.event_types.one_off.units.hours')
  }, {
    id: 'days',
    name: I18n.t('publisher.event_types.one_off.units.days')
  }];
  return <NumberField name="minBookingTime" aria-label={I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.notice.duration_label')}>
      <Select aria-label={I18n.t('publisher.event_types.availability.notice_period_fieldset.custom_unit_label')} name="minBookingTimeType" options={selectOptions} />
      <div>{I18n.t('publisher.event_types.availability.notice_period_fieldset.start_time')}</div>
    </NumberField>;
};

require("./notice_period.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notice_period.js");